import React from "react";
import * as Select from "@radix-ui/react-select";
import { ChevronDownIcon } from "@radix-ui/react-icons";

// replace with whatever list you use elsewhere
const allFonts = [
  "Lilita One",
  "Inter",
  "Bangers",
  "Staatliches",
  "AlphaWood",
  "Backso",
  "Bloopoly",
  "Cats Lover",
  "Darling Coffee",
  "DealovaSerif",
  "Drawliner",
  "DSnet Stamped",
  "GOODDC__",
  "GOODDP__",
  "Haloberry",
  "Kidazoo",
  "PatrickTime",
  "PatrickTimeRegular",
  "Pokemon Hollow",
  "Pokemon Solid",
  "Share Dong",
  "Starborn",
  "SuperMario256",
  "Tropi Land",
  "alph",
];


export default function FontPicker({ value, onChange }) {
  return (
    <Select.Root value={value} onValueChange={onChange}>
      <Select.Trigger className="flex items-center justify-between w-full rounded-md border px-3 py-2">
        <Select.Value placeholder="Select font…">
          {value ? value.replace(/['"]/g, "") : "Select font…"}
        </Select.Value>
        <Select.Icon>
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>

      <Select.Content className="overflow-hidden rounded-md border bg-white shadow-lg">
        <Select.ScrollUpButton>▲</Select.ScrollUpButton>
        <Select.Viewport>
          {allFonts.map((face) => {
            // for Konva, wrap multi-word names in quotes
            const val = face.includes(" ") ? `'${face}'` : face;
            return (
              <Select.Item
                key={face}
                value={val}
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                style={{ fontFamily: face }}
              >
                <Select.ItemText>{face}</Select.ItemText>
                <Select.ItemIndicator>✓</Select.ItemIndicator>
              </Select.Item>
            );
          })}
        </Select.Viewport>
        <Select.ScrollDownButton>▼</Select.ScrollDownButton>
      </Select.Content>
    </Select.Root>
  );
}
